import { SearchState } from './types';

export const suggestSongInitialState = {
  loading: false,
  error: false,
  processed: false,
};

export const searchInitialState: SearchState = {
  inputValue: '',
  suggestSong: suggestSongInitialState,
};
